export interface PaymentActionResult {
  orderId: string;
  success: boolean;
}
